export default "__VITE_ASSET__Dx3iE6kT__"